import { render, staticRenderFns } from "./DvRedirect.vue?vue&type=template&id=62c8e302"
import script from "./DvRedirect.vue?vue&type=script&lang=js"
export * from "./DvRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports